module.exports = __webpack_public_path__ + "static/media/spring.5554d297.png";